import { styled, Button, Typography } from '@ori-ui/mui';

const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop: theme.spacing(8),
}));

const SubmitButtton = styled(Button)(({ theme }) => ({
  minWidth: '330px',
  marginTop: theme.spacing(3),
  order: 8,
}));

const SocialWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: theme.spacing(1),
}));

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '40px',
}));

const IconText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(10),
  textAlign: 'left',
}));

// this is custom component by design
const SocialButtton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  width: '100%',
  minWidth: '330px',
  maxWidth: '500px',
  height: 'auto',
  minHeight: '40px',
  marginTop: theme.spacing(2),
  textTransform: 'none',
  boxShadow: '0px 1px 3px #00000033',
  padding: '5px 10px',
}));

const Separator = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(2),
}));

const HiddenInput = styled('input')(({ theme }) => ({
  display: 'none',
}));

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.text.secondary,
    textDecoration: 'underline',
  },
}));

const LegalNotice = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginInline: 'auto',
  marginBottom: theme.spacing(3),
  maxWidth: '500px',
}));

const AddInvitationCode = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  fontWeight: 'bold',
  marginBottom: theme.spacing(8),
  cursor: 'pointer',
}));

export {
  StyledForm,
  Separator,
  SocialButtton,
  SocialWrapper,
  SubmitButtton,
  IconWrapper,
  HiddenInput,
  IconText,
  StyledLink,
  LegalNotice,
  AddInvitationCode,
};
